import { render, staticRenderFns } from "./PlantioMarker.vue?vue&type=template&id=5fa77f80&scoped=true"
import script from "./PlantioMarker.vue?vue&type=script&lang=js"
export * from "./PlantioMarker.vue?vue&type=script&lang=js"
import style0 from "./PlantioMarker.vue?vue&type=style&index=0&id=5fa77f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa77f80",
  null
  
)

export default component.exports